import { render, staticRenderFns } from "./OPENVPNUsageShow.vue?vue&type=template&id=78cfa958&"
import script from "./OPENVPNUsageShow.vue?vue&type=script&lang=js&"
export * from "./OPENVPNUsageShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports